
<script>
import searchFormMenu from './searchFormMenu.vue'
import searchFormTabs from './searchFormTabs.vue'

export default {
  name: 'search-form',
  components: {
    searchFormMenu,
    searchFormTabs
  },
  props: {
    isLinksMode: {
      type: Boolean,
      default: () => true
    }
  },
  data: () => ({
    currentTab: 'HotelsSearch'
  }),
  computed: {
    serviceSearchForm() {
      const serviceName = this.isLinksMode
        ? this.$route.name
        : this.currentTab

      return () => import(`./forms/${serviceName}.vue`)
    }
  },
  methods: {
    tabChange(tabName) {
      this.currentTab = tabName
    }
  }
}
</script>

<template>
  <div class="search-form">
    <search-form-menu
      v-if="isLinksMode"
    />
    <search-form-tabs
      v-else
      @onTabChange="tabChange"
    />
    <component :is="serviceSearchForm" />
  </div>
</template>
